import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUndoAlt } from "@fortawesome/free-solid-svg-icons";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

export default function ResetIcon() {
  return <FontAwesomeIcon icon={faUndoAlt as IconProp} />;
}
